<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" v-bind:href="'#t1'+rowData.cfop_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.cfop_id+''">
          <table class="table-striped" id="mais">
            <thead>
            <tr>
              <th style="width: 25%">Aliquota</th>
              <th style="width: 30%">Descrição</th>
              <th style="width: 25%">Código ERP</th>
              <th style="width: 10%">Status</th>
            </tr>
            </thead>
            <tbody>

            </tbody>
          </table>
        </div><!--.tab-pane-->
      </div><!--.tab-content-->
    </div>
  </div>
</template>
<script>
import accounting from 'accounting'
export default {
  data () {
    return {
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    formatNumber (value) {
      return accounting.formatNumber(value, 2, '.', ',')
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onActivateDesactivate(action, data, tipo)
    {
      // Tipo = true = Checkbox
      if(tipo)
      {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({ id: data.cfonatali_id, status: action, origem: 2 });
      }
      else
      {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj)=>{
          this.helpForm.statusRecord.push({ id: obj, status: action, origem: 2 })
        });
      }

      this.helpForm.post('/api/cfopregra/status').then(response =>
      {
        new ReturnApi(response, this);
        Event.$emit('reloadVuetable', data);
      })
          .catch(errors =>
          {
            new ReturnApi(errors, this)
          });

    },
  },

}
</script>
